
import Yup from 'yup';
import MobileDetect from 'mobile-detect';
import AppConstants from 'AppConstants';

const PRODUCT_TYPES = AppConstants.PRODUCT_TYPES;
const DELIVERY_TYPE = AppConstants.DELIVERY_TYPE;

const DELIVERY_LOCATION_TYPE = AppConstants.DELIVERY_LOCATION_TYPE;
const OUTSIDE_KTM_VALLEY = DELIVERY_LOCATION_TYPE.OUTSIDE_KTM_VALLEY;

const AppUtil = {
	isMobileDevice: function() {
		return new MobileDetect(window.navigator.userAgent).mobile() !== null;
	},
	isDashainRunning: function() {
		const startDate = new Date(2019, 9, 5);
		const endDate = new Date(2019, 9, 11);
		const today = new Date();

		return today.getTime() > startDate.getTime() && today.getTime() < endDate.getTime();
	},
	startsWithNumber: function(arg) {
		if(!arg)
			return false;

		return arg.match(/^\d/);
	},
	phoneNumberValidation: function() {
		const phoneNumberErrMsg = "Enter your valid 10 digit Nepali Phone Number.";
		return Yup.string().trim().required(phoneNumberErrMsg).matches(/^9[678][0-9]{8}$/, phoneNumberErrMsg);
	},

	formatNumber: function(arg) {
		return arg.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	},

	scrollToHashTagIfAny: function(offset) {
		const id = window.location.hash.replace("#", "");
		if(id !== "") {
			setTimeout(() => {
				var element = document.getElementById(id);
				var elementPosition = element.getBoundingClientRect().top;
				var offsetPosition = elementPosition - (offset || 0);
				
				if (element) 
					window.scrollTo({top: offsetPosition, behavior: "smooth"});
    		}, 0);
			
		}
	},

	//Scroll Options available here: https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
	scrollToElement: function(elementId, scrollOptions) {
		var element = document.getElementById(elementId);

		if(element)
			element.scrollIntoView(scrollOptions);
	},
	scrollToTop: function() {
		window.scroll(0, 0);
	},
	isAuthorizedForProduct: function(user, product) {
		const isAuthorized = user && (user.id === product.creator.id || user.userType === AppConstants.USER_TYPE.ADMIN);
		return isAuthorized;
	},
	isAdminUser: function(user) {
		const isAdmin = user && user.userType === AppConstants.USER_TYPE.ADMIN;
		return isAdmin;
	},
	getProductURL: function(product) {
		const productType = PRODUCT_TYPES[product.productType];
		const productTypeStr = productType.url;

		if(productType.val === 'OTHER')
			return "/shop/"+encodeURIComponent(product.title)+"/"+product.id;
			
		return "/"+productTypeStr+"/"+encodeURIComponent(product.title)+"/"+product.id;
	},
	getProductEditURL: function(product) {
		const productTypeStr = PRODUCT_TYPES[product.productType].url;
		return "/"+productTypeStr+"/edit/"+encodeURIComponent(product.title)+"/"+product.id;
	},
	getAddSubProductURL: function(product) {
		const productTypeStr = PRODUCT_TYPES[product.productType].url;
		return "/"+productTypeStr+"/addSub/"+product.title+"/"+product.id;
	},
	getDesignerURL: function(creator) {
		if(creator.storeName)
			return "/store/"+creator.storeName.replace(/ /g, "-");

		if(creator.userType && creator.userType === AppConstants.USER_TYPE["PHOTOGRAPHER"])
			return "/photographer/"+creator.username+"/"+creator.id;
		else if(creator.userType && creator.userType === AppConstants.USER_TYPE["FASHION_DESIGNER"])
			return "/fashion-designer/"+creator.username+"/"+creator.id;
		else if(creator.userType && (creator.userType === AppConstants.USER_TYPE["DESIGNER"] || creator.userType === AppConstants.USER_TYPE["INFLUENCER"]))
			return "/designer/"+creator.username+"/"+creator.id;

		return "#";
	},
	getCreaterName: function(creator) {
		if(creator.storeName)
			return creator.storeName;

		return creator.username;
	},
	getProductTitle: function(product) {
		const productTypeLabel = PRODUCT_TYPES[product.productType].label;
		if(product.productType === PRODUCT_TYPES.T_SHIRT.val || product.title.indexOf(productTypeLabel) >= 0)
			return product.title;

		return product.title+" - "+productTypeLabel;
	},
	findProductTypeFromURL: function(productTypeURL) {
		const matchedProductTypes = Object.keys(PRODUCT_TYPES).filter(k => PRODUCT_TYPES[k].url.toLowerCase() === productTypeURL.toLowerCase());

		return matchedProductTypes.length === 1? PRODUCT_TYPES[matchedProductTypes[0]]: null;
	},
	calculatePercentDiff: function(newValue, baseValue) {
		return ((newValue - baseValue)/baseValue) * 100.0;
	},
	getProductSizeOptions: function(product) {
		const productSizes = AppUtil.getSizeInfo(product);
		const sizeOptions = AppUtil._getSizeOptions(productSizes, product.outofStock? true: false);
		return sizeOptions;
	},
	_getSizeOptions: function(sizeMetaData, disableAll) {
		const sizes = Object.keys(sizeMetaData);
		const sizeOptions = [];
		for(var i = 0; i < sizes.length; i ++) {
			const size = sizes[i];
			let label = sizeMetaData[size].label;

			if(disableAll && label.toLowerCase().indexOf("out of stock") < 0)
				label += " - Out of Stock";
				
			sizeOptions.push({label: label, value: size, 
								disabled: disableAll || label.toLowerCase().indexOf("out of stock") >= 0});
		}

		return sizeOptions;
	},
	getOrderSizeString: function(order, product, shortStr) {
		const orderSizeMetaData = order.sizeMetaData;

		if(!product) {
			if(order.isBulkOrder) {
				return Object.keys(order.sizeQuantity).map(s => {
					return order.sizeQuantity[s] + " x " + s;
				}).join(", ");
			} else {
				const quantity = order.quantity;
				const orderSizes = order.productSizes;
				return quantity + " x " + orderSizes.toString();
			}
		} else {
			const sizeMetaData = orderSizeMetaData || AppUtil.getSizeInfo(product);
			if(order.isBulkOrder){
				return Object.keys(order.sizeQuantity).map(s => {
					return order.sizeQuantity[s] + " x " + sizeMetaData[s].label;
				}).join(", ");
			} else {
				const quantity = order.quantity;
				const orderSizes = order.productSizes;
				if(this.isCoupleProduct(product))
					return quantity + " x Pair of Male: "+this._getSizeString([orderSizes[0]], sizeMetaData, shortStr)
							+", Female: "+this._getSizeString([orderSizes[1]], sizeMetaData, shortStr);
				else
					return quantity + " x " + this._getSizeString(orderSizes, sizeMetaData, shortStr);
			}
		}
	},
	_getSizeString: function(orderSizes, sizeMetaData, shortStr) {
		return orderSizes.map(s => {
				const size = sizeMetaData[s];
				
				if(!size)
					return s;

				return shortStr? size.shortLabel: size.label;
			}).toString();
	},
	getSizeInfo: function(product) {
		return product.sizeMetaData? product.sizeMetaData: PRODUCT_TYPES[product.productType].SIZE;
	},
	isCoupleProduct: function(product) {
		if(!product)
			return false;
			
		const productType = product.productType;
		return product.title.toLowerCase().indexOf("couple") >= 0 
				&& (productType === PRODUCT_TYPES.T_SHIRT.val 
					|| productType === PRODUCT_TYPES.SWEAT_SHIRT.val
					|| productType === PRODUCT_TYPES.HOODIES.val);
	},
	fetchYoutubeVideoID: function(link) {
		if(link && link.indexOf("https://www.youtube.com/watch?v=") === 0)
			return link.split("=")[1].split("&")[0];

		if(link && link.indexOf("https://youtu.be/") === 0)
			return link.split("https://youtu.be/")[1];

		if(link && link.indexOf("https://m.youtube.com/watch?v=") === 0)
			return link.split("https://m.youtube.com/watch?v=")[1].split("&")[0];

		if(link && link.indexOf("https://www.youtube.com/embed/") === 0)
			return link.split("https://www.youtube.com/embed/")[1];

		return null;
	},

	getDeliveryTime: function(productType, deliveryType) {
		const isPhotoFrame = productType === PRODUCT_TYPES['PHOTO_FRAME'].val;
		if(isPhotoFrame){
			return "3-6 business days";
		} else {
			if(deliveryType === DELIVERY_TYPE.REGULAR.val) return "2-3 business days";
			else return "next 24 hours";
		}
	},
	getAppLogo: function() {
		const year = new Date().getFullYear();

		let logoImg = "logo.png";
		if(year === 2020) {
			const currMin = new Date().getMinutes();

			if(currMin % 2 === 0) logoImg = "santa_logo3.png";
			else if(currMin % 3 === 0) logoImg = "santa_logo2.png";
			else logoImg = "santa_logo1.png";
		}

		return "/images/"+logoImg;
	},
	getAppIcon: function() {
		const year = new Date().getFullYear();

		let iconImg = "canvas_icon.png";
		if(year === 2020) {
			iconImg = "canvas_icon_santa.png";
		}

		return "/images/"+iconImg;
	},

	isCustomProduct: function(product) {
		if(!product)
			return false;
		
		const productTypes = Object.keys(AppConstants.PRODUCT_TYPES);
		
		for(var i = 0; i < productTypes.length;i++) {
			const customProductsIds = AppConstants.CUSTOM_PRODUCTS[productTypes[i]];
			if(customProductsIds && customProductsIds.indexOf(product.id) >= 0)
				return true;
		}
		return false;
	},
	getDefaultDeliveryType: function(productType, locationType) {
		if(productType === AppConstants.PRODUCT_TYPES['PHOTO_FRAME'].val) {
			return DELIVERY_TYPE.REGULAR.val;
		} else {
			if(locationType === OUTSIDE_KTM_VALLEY.val)
				return DELIVERY_TYPE.REGULAR.val;
		}
	
		return '';
	},
	getDefaultProductImage: function(product) {
		let productImage = '';
		if (product.productType !== AppConstants.PRODUCT_TYPES['T_SHIRT'].val) productImage = product.productImages[0];
		else if (product.productImages.length === 1) productImage = product.productImages[0];
	
		return productImage;
	},
	getUrlQueryParams: function(location) {
		let queryParams = {};

		location.search.substring(1).split("&").forEach(p => {
			const data = p.split("=");
			queryParams[data[0]] = data[1];
		});

		return queryParams;
	},
	getLocationExtraCost: function(locationType, product) {
		//TODO: to make it dynamic per product, we have this information in the database instead
		const productDeliveryLocationType = PRODUCT_TYPES[product.productType].deliveryLocationType;
		
		if(productDeliveryLocationType && productDeliveryLocationType[locationType]) {
			return productDeliveryLocationType[locationType].extraCost;
		}

		return DELIVERY_LOCATION_TYPE[locationType].extraCost;
	}
}


export default AppUtil;


// WEBPACK FOOTER //
// ./src/AppUtil.js